import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './auth/auth.guard';
import { storyRoutes } from './story/story.routes';
import { UserSignupComponent } from './user-signup/user-signup.component';
import { attractionRoutes } from './attraction/attraction.routes';
import { PrivacyComponent } from "./privacy/privacy.component";
import { TermsComponent } from "./terms/terms.component";
import { HomeMainComponent } from './home/home-main/home-main.component';
import { SuperAdminComponent } from './super-admin/super-admin.component';
import { StoryApprovalQueueComponent } from './story-approval-queue/story-approval-queue.component';

// const routes: Routes = [{
//   path: '',
//   component: HomeComponent,
//   children: [
//     { path: 'login', component: LoginComponent }
//   ]
// }];

const routes: Routes = [
  { path: 'admin',
    component: HomeMainComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: HomeComponent },
      { path: 'login', component: LoginComponent },
      { path: 'privacy', canActivate: [AuthGuard], component: PrivacyComponent },
      { path: 'terms', canActivate: [AuthGuard], component: TermsComponent },
      { path: 'sudo', canActivate: [AuthGuard], component: SuperAdminComponent },
      { path: 'story-approval', canActivate: [AuthGuard], component: StoryApprovalQueueComponent },
      ...storyRoutes,
      ...attractionRoutes
    ]
  },
  { path: '', component: UserSignupComponent, pathMatch: 'full' },

];




@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
